export default __webpack_public_path__ + "static/media/menu-05-api-b.a83341e9.svg";